import Vue from 'vue'
import Vuex from 'vuex'
// import * as actions from './actions'
// import * as getters from './getters'
import user from './modules/user'
import orders from './modules/orders'
import sceneOrders from './modules/swapOrders'
import commission from './modules/commission'
// import createLogger from '../../../src/plugins/logger'
import activity from './modules/activity'
import city from './modules/city'
import positionview from './modules/positionview'
import invitational from './modules/invitational'
import withdrawList from './modules/withdraw'
import payMoney from './modules/paymoney'


Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  // actions,
  // getters,
  modules: {
    user,
    orders,
    commission,
    activity,
    city,
    positionview,
    invitational,
    withdrawList,
    payMoney,
    sceneOrders
  },
  strict: debug
  // ,plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js